

import React from 'react';
import moment from 'moment'

import { Table, Space } from "antd";

export default function MonthlySubTable({ data, interval }) {


const columns = [
        {
            title: interval === "year" ? 'Anno' : 'Mese',
            dataIndex: 'key_as_string',
            key: 'key_as_string',
            render: (text, row) => (
                <Space size="middle" key={row.key}>
                    { interval === "year" ? <p>{moment(row.key_as_string).format("YYYY")}</p> : <p>{moment(row.key_as_string).format("MMMM YYYY")}</p>}
                </Space>
            ),
        },
        {
            title: 'Articoli',
            dataIndex: 'key',
            key: 'key',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.key}>{articolo.key} : {articolo.quantity}</li>
                );
            },
        },
        {
            title: 'ID Prodotto',
            dataIndex: 'key',
            key: 'key',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.key}>{articolo.productId}</li>
                );
            },
        },
        {
            title: 'Quantita',
            dataIndex: 'key',
            key: 'quantity',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.key}> {articolo.quantity.toFixed(2)} </li>
                );
            },
        },
        {
            title: 'Prezzo/unita  medio',
            dataIndex: 'key',
            key: 'avg_unit_price',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.key}> {articolo.unit_price.toFixed(2)} </li>
                );
            },
        },
        {
            title: 'Totale venduto',
            dataIndex: 'key',
            key: 'totalSold',
            render: (text, row) => {
                return row.articoli.buckets.map((articolo) =>
                    <li key={articolo.key}> {articolo.totalSold.toFixed(2)} </li>
                );
            },
        },
    ];
    return <Table columns={columns}
        pagination={true}
        dataSource={data} />;
} 
